/**
 * ChannelRulesOverview - Zeigt aktive Regeln pro Channel als Zusammenfassung
 */

import { Image, Type } from 'lucide-react'

interface ChannelRulesOverviewProps {
  imageRuleCount: number
  textRuleCount: number
}

export function ChannelRulesOverview({ imageRuleCount, textRuleCount }: ChannelRulesOverviewProps) {
  const total = imageRuleCount + textRuleCount

  if (total === 0) {
    return (
      <p className="text-sm text-neutral-500 dark:text-neutral-400">
        Keine Regeln konfiguriert
      </p>
    )
  }

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-1.5">
        <Image className="h-4 w-4 text-emerald-500" />
        <span className="text-sm text-neutral-600 dark:text-neutral-400">
          {imageRuleCount} Bild-Regel{imageRuleCount !== 1 ? 'n' : ''}
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <Type className="h-4 w-4 text-primary-500" />
        <span className="text-sm text-neutral-600 dark:text-neutral-400">
          {textRuleCount} Text-Regel{textRuleCount !== 1 ? 'n' : ''}
        </span>
      </div>
    </div>
  )
}
